import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the DatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'datetime',
})
export class DatenewPipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: string) { // ...args -> quando aceita infinitos argumentos?

        return new Date(value)

    }

}



// WEBPACK FOOTER //
// ./src/pipes/datenew/datenew.ts